const initialState = {
  loading: null,
  data: null,
  error: [null, null],
  filters: {},
};

export default initialState;
